export default __webpack_public_path__ + "static/media/usa-icon.08ca13e9.svg";